import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import OwnerList from '../OwnerList';
import { IUserInitials } from '../../common/models/user/IUserInitials';
import { IUpdateOwner } from '../../common/models/candidate/IUpdateOwner';
import RegularButton from '../../components/RegularButton';
import ModalWindow from '../../components/ModalWindow';
import styles from './styles.module.scss';

interface IChangeOwnerProps {
  ids: string[];
  variant: 'candidates' | 'prospects';
  isShown: boolean;
  onHide: IBindingAction;
  updateOwner: IBindingCallback1<IUpdateOwner>;
}

const ChangeOwner: FunctionComponent<IChangeOwnerProps> = ({
  isShown,
  ids,
  variant,
  onHide,
  updateOwner
}) => {
  const [owner, setOwner] = useState<IUserInitials | undefined>();

  const onCancel = () => {
    setOwner(undefined);
    onHide();
  };

  const onUpdateOwner = () => {
    updateOwner({
      owner: owner as IUserInitials,
      ids
    });
    onCancel();
  };
  const isVariantCandidates = variant === 'candidates';
  return (
    <ModalWindow
      isShown={isShown}
      onHide={onCancel}
      contentClassName="small-modal modal-wrapper"
    >
      <div className={styles.reassignModal}>
        <header className="custom-modal-header">
          <FormattedMessage
            id={isVariantCandidates ? 'bulkActions.reassignCandidates' : 'bulkActions.reassignProspects'}
            defaultMessage={isVariantCandidates
              ? 'Reassign candidate(s) to different user'
              : 'Reassign prospect(s) to different user'}
          />
        </header>
        <main className={styles.reassignBody}>
          <OwnerList onSelect={setOwner} selectedId={owner?.id} />
        </main>
        <footer className="modal-footer-bttns">
          <RegularButton
            textIntlId="cancel"
            defaultMessage="Cancel"
            onClick={onCancel}
            variant="tertiary"
          />
          <RegularButton
            textIntlId="done"
            defaultMessage="Done"
            onClick={onUpdateOwner}
            disabled={!owner}
          />
        </footer>
      </div>
    </ModalWindow>
  );
};

export default ChangeOwner;
